<div class="content">
  <mat-tab-group [mat-stretch-tabs]="false">
    <mat-tab label="Details">
      <table class="data-table">
        <tr>
          <td class="label">Order ID:</td>
          <td class="data"> {{prmsOrderSummary().orderNumber}}</td>
        </tr>
        <tr>
          <td class="label">Customer:</td>
          <td class="data"> {{prmsOrderSummary().customerNumber}}</td>
        </tr>
        <tr>
          <td class="label">Status:</td>
          <td class="data"> {{prmsOrderSummary().status}}</td>
        </tr>
        <tr>
          <td class="label">Customer PO:</td>
          <td class="data"> {{prmsOrderSummary().customerPo}}</td>
        </tr>
        <tr>
          <td class="label">Order Date:</td>
          <td class="data"> {{prmsOrderSummary().enteredDate | date:'MM-dd-yy'}}</td>
        </tr>
        <tr>
          <td class="label">Order Type:</td>
          <td class="data"> {{prmsOrderSummary().orderType}}</td>
        </tr>
        <tr>
          <td class="label">Project Name:</td>
          <td class="data"> {{prmsOrderSummary().projectName}}</td>
        </tr>
      </table>
      <table class="data-table">
        <tr>
          <td class="label">Ship To Name:</td>
          <td class="data">{{ prmsOrderSummary().shipToAttention }}</td>
        </tr>
        <tr>
          <td class="label">Address:</td>
          <td class="data">
            {{ prmsOrderSummary().shipToAddress1 }}
            @if(prmsOrderSummary().shipToAddress2){
            <br />, {{ prmsOrderSummary().shipToAddress2 }}
            }
            @if(prmsOrderSummary().shipToAddress3){
            <br />, {{ prmsOrderSummary().shipToAddress3 }}
            }
          </td>
        </tr>
        <tr>
          <td class="label">City, State, Zip:</td>
          <td class="data"> {{ prmsOrderSummary().shipToCity }}, {{ prmsOrderSummary().shipToState }} {{
            prmsOrderSummary().shipToZip }}
          </td>
        </tr>
        <tr>
          <td class="label">Country:</td>
          <td class="data">{{ prmsOrderSummary().shipToCountry }}</td>
        </tr>
        <tr>
          <td class="label">Ship Via:</td>
          <td class="data">{{ prmsOrderSummary().shipVia }}</td>
        </tr>
        <tr>
          <td class="label">Reference:</td>
          <td class="data">{{ prmsOrderSummary().referenceNumber }}</td>
        </tr>
      </table>
      <table class="data-table">
        <tr>
          <td class="label">Order Amount:</td>
          <td class="data">{{ prmsOrderSummary().orderAmount | currency:'USD' }}</td>
        </tr>
        <tr>
          <td class="label">Remaining Amount:</td>
          <td class="data">{{ prmsOrderSummary().remainingAmount | currency:'USD' }}</td>
        </tr>
        <tr>
          <td class="label order-text">Order Text:</td>
          <td class="data">
            @for(line of prmsOrderSummary().orderText; track line){
            <p>{{ line }}</p>
            }
          </td>
        </tr>
      </table>

      <mat-divider></mat-divider>
      <div class="results-table">
        @if(isBusy()){
        <div class="spinner-container">
          <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
          <p>Loading order lines...</p>
        </div>
        }
        @if(detailsErrorMessage()){<div class="error-message">{{ detailsErrorMessage() }}</div>}
        @if(prmsOrderSummary().lines.length === 0 && !isBusy()){No order lines found.}
        @if(prmsOrderSummary().lines.length > 0 && !isBusy() && !detailsErrorMessage()){
        <table mat-table [dataSource]="orderLineDataSource" matSort class="mat-elevation-z2 bordered-table">

          <ng-container matColumnDef="lineNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Order Line </th>
            <td mat-cell *matCellDef="let row"> {{ row.lineNumber }} </td>
          </ng-container>

          <ng-container matColumnDef="productNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ProductNumber </th>
            <td mat-cell *matCellDef="let row"> {{ row.productNumber }} </td>
          </ng-container>

          <ng-container matColumnDef="productDescription">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Description </th>
            <td mat-cell *matCellDef="let row"> {{ row.productDescription }} </td>
          </ng-container>

          <ng-container matColumnDef="unitPrice">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Unit Price</th>
            <td mat-cell *matCellDef="let row"> {{ row.unitPrice | currency:'USD'}} </td>
          </ng-container>

          <ng-container matColumnDef="quantityOrdered">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Order Quantity </th>
            <td mat-cell *matCellDef="let row"> {{ row.quantityOrdered }} </td>
          </ng-container>

          <ng-container matColumnDef="quantityShipped">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Quantity Shipped </th>
            <td mat-cell *matCellDef="let row"> {{ row.quantityShipped }} </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
            <td mat-cell *matCellDef="let row"> {{ row.status }} </td>
          </ng-container>

          <ng-container matColumnDef="requestedDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Requested Date </th>
            <td mat-cell *matCellDef="let row"> {{ row.requestedDate | date:'MM-dd-yy' }} </td>
          </ng-container>

          <ng-container matColumnDef="scheduledDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Scheduled Date </th>
            <td mat-cell *matCellDef="let row"> {{ row.scheduleDate | date:'MM-dd-yy' }} </td>
          </ng-container>

          <ng-container matColumnDef="promiseDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Promise Date </th>
            <td mat-cell *matCellDef="let row"> {{ row.promiseDate | date:'MM-dd-yy' }} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="orderLineColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: orderLineColumns;"></tr>
        </table>
        }
      </div>
    </mat-tab>
    <mat-tab label="Shipments">
      <div class="results-table">
        @if(isBusy()){
        <div class="spinner-container">
          <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
          <p>Loading order shipments...</p>
        </div>
        }
        @if(shipmentsErrorMessage()){<div class="error-message">{{ shipmentsErrorMessage() }}</div>}
        @if(invoiceErrorMessage()){<div class="error-message">{{ invoiceErrorMessage() }}</div>}
        @if(shipmentsDataSource.data.length === 0 && !isBusy()){No shipments found.}
        @if(shipmentsDataSource.data.length > 0 && !isBusy() && !shipmentsErrorMessage()?.length){
        <table mat-table [dataSource]="shipmentsDataSource" matSort class="mat-elevation-z2 bordered-table">

          <ng-container matColumnDef="lineNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Order Line </th>
            <td mat-cell *matCellDef="let row"> {{ row.lineNumber }} </td>
          </ng-container>

          <ng-container matColumnDef="productNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ProductNumber </th>
            <td mat-cell *matCellDef="let row"> {{ row.productNumber }} </td>
          </ng-container>

          <ng-container matColumnDef="productDescription">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Description </th>
            <td mat-cell *matCellDef="let row"> {{ row.productDescription }} </td>
          </ng-container>

          <ng-container matColumnDef="invoiceNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Invoice Number</th>
            <td mat-cell *matCellDef="let row" (click)="downloadInvoice(row)">
              @if(row.invoiceDownloading){
              <span> Downloading... </span>
              } @else {
              <span class="hyperlink">{{ row.invoiceNumber }}</span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="quantityOrdered">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Order Quantity </th>
            <td mat-cell *matCellDef="let row"> {{ row.quantityOrdered }} </td>
          </ng-container>

          <ng-container matColumnDef="quantityShipped">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Quantity Shipped </th>
            <td mat-cell *matCellDef="let row"> {{ row.quantityShipped }} </td>
          </ng-container>

          <ng-container matColumnDef="shipDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Shipment Date </th>
            <td mat-cell *matCellDef="let row"> {{ row.shipDate}} </td>
          </ng-container>

          <ng-container matColumnDef="shipVia">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Ship Via </th>
            <td mat-cell *matCellDef="let row"> {{ row.shipVia }} </td>
          </ng-container>

          <ng-container matColumnDef="trackingNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Tracking Number </th>
            <td mat-cell *matCellDef="let row"> {{ row.trackingNumber }} </td>
          </ng-container>

          <ng-container matColumnDef="completeFlag">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Completed </th>
            <td mat-cell *matCellDef="let row"> {{ row.completeFlag }} </td>
          </ng-container>

          <ng-container matColumnDef="download">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> BOL </th>
            <td mat-cell *matCellDef="let row" (click)="row.bolExists && downloadBol(row)">
              @if(row.bolDownloading){
              <span> Downloading... </span>
              } @else {
              <span [class.hyperlink]="row.bolExists"> Download </span>
              }
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="shipmentLineColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: shipmentLineColumns;"></tr>
        </table>
        }
      </div>
    </mat-tab>
  </mat-tab-group>
</div>